import {
  ApplicationConfig,
  importProvidersFrom,
  mergeApplicationConfig,
  provideZonelessChangeDetection,
} from '@angular/core';
import { AppCoreModule } from './app.core.module';
import { AppRoutingModule } from './app-routing.module';
import { environmentBrand } from '../environments/environment.brand';
import { ENVIRONMENT_BRAND } from '@lentau/ui-kit/core/tokens/environment.brand';
import { RETAIL_BRAND_ASSET, RETAIL_BRAND_NAME } from '@lentau/ui-kit/core/tokens/brand';
import { BrandsAssets, RetailBrands } from '@lentau/ui-kit/core/tokens/constants';
import { multiBrandCommonConfig } from '@lentau/bootstrap/application/app-common/app.config.common';

const commonConfig: ApplicationConfig = {
  providers: [
    importProvidersFrom(AppRoutingModule, AppCoreModule),
    provideZonelessChangeDetection(),
    { provide: 'googleTagManagerId', useValue: environmentBrand.GTM_TAG_ID },
    {
      provide: ENVIRONMENT_BRAND,
      useValue: environmentBrand,
    },
    {
      provide: RETAIL_BRAND_NAME,
      useValue: RetailBrands.MONETKA,
    },
    {
      provide: RETAIL_BRAND_ASSET,
      useValue: BrandsAssets.MONETKA,
    },
  ],
};

export const appCommonConfig: ApplicationConfig = mergeApplicationConfig(multiBrandCommonConfig, commonConfig);
